function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#6851C9",
  d: "M6.146 11.5c2.892 0 5.354-2.462 5.354-5.354C11.5 3.005 9.078.5 6.146.5 2.962.5.5 2.962.5 6.146.5 9.078 3.005 11.5 6.146 11.5zm0-3.976a1.378 1.378 0 110-2.756 1.378 1.378 0 010 2.756z"
});

var SvgImgCircle3 = function SvgImgCircle3(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIj4KICA8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM2ODUxQzkiIGQ9Ik02LjE0NjM0MTQ2LDExLjUgQzkuMDM3NTY2MTIsMTEuNSAxMS41LDkuMDM3NTY2MTIgMTEuNSw2LjE0NjM0MTQ2IEMxMS41LDMuMDA0NzY2NDggOS4wNzgyMzI4MiwwLjUgNi4xNDYzNDE0NiwwLjUgQzIuOTYyNDMzODgsMC41IDAuNSwyLjk2MjQzMzg4IDAuNSw2LjE0NjM0MTQ2IEMwLjUsOS4wNzgyMzI4MiAzLjAwNDc2NjQ4LDExLjUgNi4xNDYzNDE0NiwxMS41IFogTTYuMTQ2MzQxNDYsNy41MjQzOTAyNCBDNS4zODUyNjYxNCw3LjUyNDM5MDI0IDQuNzY4MjkyNjgsNi45MDc0MTY3OSA0Ljc2ODI5MjY4LDYuMTQ2MzQxNDYgQzQuNzY4MjkyNjgsNS4zODUyNjYxNCA1LjM4NTI2NjE0LDQuNzY4MjkyNjggNi4xNDYzNDE0Niw0Ljc2ODI5MjY4IEM2LjkwNzQxNjc5LDQuNzY4MjkyNjggNy41MjQzOTAyNCw1LjM4NTI2NjE0IDcuNTI0MzkwMjQsNi4xNDYzNDE0NiBDNy41MjQzOTAyNCw2LjkwNzQxNjc5IDYuOTA3NDE2NzksNy41MjQzOTAyNCA2LjE0NjM0MTQ2LDcuNTI0MzkwMjQgWiIvPgo8L3N2Zz4K";
export { SvgImgCircle3 as ReactComponent };